<template>
  <div id='content'>
     <!-- Carousel de personas -->
    <div class='card-row' v-if='personas.length !== 0'>
      <!-- Boton anterior -->
      <v-img  v-if='totalGrupos > 1'
        class='btn-generico'
        :class='{ disabled : !hasPrev }'
        :src='require("@/assets/images/Btn-arrowLeft.gif")'
        @click='grupoAnterior'
        :disabled='!hasPrev'
        :alt='msj.anterior'
      ></v-img>
      <!-- FIN. Boton anterior -->
      <div v-for='(persona, index) in personasMostrar'
        :persona='persona'
        :key='index'
        @click='selectCard (persona, index)'
        class='card'
        :class='{ selected : persona.isSelected }'
      >
        <img class='card-image'
          :class='{ selected : persona.isSelected }'
          v-if='persona.mspersonaconfoto === "N"'
          :src='require("@/assets/images/no_photo.png")'
        >
        <img class='card-image'
          :class='{ selected : persona.isSelected }'
          v-else
          :src='getImgUrl(persona.mspersonauid)'
        >
        <div class='card-footer'
          :class='{ selected : persona.isSelected }'>
          <p class='card-text' :class='{ selected : persona.isSelected }' v-if='persona.mspersonaalias'>{{ persona.mspersonaalias }}</p>
          <p class='card-text' :class='{ selected : persona.isSelected }' v-else>{{ persona.mspersonanombre }}</p>
        </div>
      </div>
      <!-- Boton siguiente -->
      <img v-if='totalGrupos > 1'
        class='btn-generico'
        :class='{ disabled : !hasNext }'
        :src='require("@/assets/images/Btn-arrowRight.gif")'
        @click='grupoSiguiente'
        :disabled='!hasNext'
        :alt='msj.siguiente'
      />
      <!-- FIN. Boton siguiente -->
    </div>
    <!-- Sin personas -->
    <div class='card-row' v-else>
      <div class='card-no-data'>
        <img class='card-image' :src='require("@/assets/images/no_photo.png")'>
      </div>
    </div>
    <!-- FIN. Sin personas -->
    <!-- FIN. Carousel de personas -->
    <!-- Indicador de los grupos -->
    <div class='centrado'>
      <div v-for='n in totalGrupos' :key='n'>
        <img
          v-if='n === grupoMostrar'
          :src='require("@/assets/images/Ico-grupo-sel.png")'
        >
        <img
          class='pointer'
          v-else
          :src='require("@/assets/images/Ico-grupo-no-sel.png")'
          @click='selectGrupo(n)'
        >
      </div>
      <small v-if='this.personas.length > 0' class='pt-1 pl-2'>{{ msj.totalper }}: {{ this.personas.length }}</small>
    </div>
    <!-- FIN. Indicador de los grupos -->
    <!-- Select de personas, botones anhadir quitar -->
    <div class='centrado pt-2'>
      <!-- Select personas -->
      <div class='col-md-4'>
        <select class='form-control' v-model='personaAdd'>
          <option disabled value='0' selected='selected'>{{ msj.addpersona }}</option>
          <option v-for="personaSelect in personasCompletas" :key="personaSelect.mspersonaid" :value="personaSelect.mspersonaid">
            {{ personaSelect.mspersonaapellido1 ? personaSelect.mspersonaapellido1 : '' }}
            {{ personaSelect.mspersonaapellido2 ? personaSelect.mspersonaapellido2 : '' }}
            {{ personaSelect.mspersonanombre ? ', ' + personaSelect.mspersonanombre : '' }}
            {{ personaSelect.mspersonaalias ? ' (' + personaSelect.mspersonaalias + ')' : '' }}
          </option>
        </select>
      </div>
      <!-- FIN. Select personas -->
      <!-- Botones anhadir quitar -->
      <img
        class='btn-generico'
        :class='{ disabled : !isPersonaAddSelected }'
        :src='require("@/assets/images/Btn-mas.gif")'
        @click='addPersona'
        :disabled='!isPersonaAddSelected'
        :alt='msj.anhadir'
      />
      <img
        class='btn-generico pl-2'
        :class='{ disabled : !isPersonaRemSelected }'
        :src='require("@/assets/images/Btn-menos.gif")'
        @click='removePersona'
        :disabled='!isPersonaRemSelected'
        :alt='msj.quitar'
      />
      <!-- FIN. Botones anhadir quitar -->
    </div>
    <!-- FIN. Select de personas, botones anhadir quitar -->
    <!-- TABS -->
    <div class='altura-250 pt-4'>
        <div v-if="selectedPersona && selectedCard !== -1">
          <vue-tabs @tab-change='handleTabChange' v-model='tabNombre'>
            <!-- Tab.PersonasTabDatosPersonales -->
            <v-tab :title='tabnombres.tabdatos' >
              <PersonasTabDatosPersonales :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' :clickGuardarDatosPersona='event.clickGuardarDatosPersona'/>
            </v-tab>
            <!-- Tab.PersonasTabFoto -->
            <v-tab :title='tabnombres.tabfoto' >
              <PersonasTabFoto :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' :clickGuardarFotoPersona='event.clickGuardarFotoPersona' :clickBorrarFotoPersona='event.clickBorrarFotoPersona'/>
            </v-tab>
            <!-- Tab.PersonasTabVacaciones -->
            <v-tab :title='tabnombres.tabvacaciones' >
              <PersonasTabVacaciones :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' />
            </v-tab>
            <!-- Tab.PersonasTabFichajes -->
            <v-tab :title='tabnombres.tabfichajes' >
              <PersonasTabFichajes :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' />
            </v-tab>
            <!-- Tab.PersonasTabFichajesDetalle -->
            <v-tab :title='tabnombres.tabfichajesdetalle' >
              <PersonasTabFichajesDetalle :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' />
            </v-tab>
            <!-- Tab.PersonasTabJornada -->
            <v-tab :title='tabnombres.tabjornada' >
              <PersonasTabJornada :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' />
            </v-tab>
            <!-- Tab.PersonasTabMantCalenlab -->
            <v-tab :title='tabnombres.tabmantcalenlab' >
              <PersonasTabMantCalenlab :personaParam='selectedPersona' :tabSeleccionado='tabSeleccionado' :clickGuardarCalenlab='event.clickGuardarCalenlab' :clickBorrarCalenlab='event.clickBorrarCalenlab' />
            </v-tab>
            <!-- Tab.CreatePersona -->
            <v-tab :title='tabnombres.tabcrear'>
              <CreatePersona :tabSeleccionado='tabSeleccionado' :clickCrearPersona='event.clickCrearPersona' @recargaPersonas="init"/>
            </v-tab>
          </vue-tabs>
        </div>
    </div>
    <!-- FIN. TABS -->
    <!-- Footer de botones -->
    <div id='footer'>
      <!-- Esc salir -->
      <img class='btn-footer-izq' src='@/assets/images/Btn-ESC.gif'>
      <label class='txt-footer-izq'>{{ $t('lang.comun.salir') }}</label>
      <!-- Guardar Datos Personales -->
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' v-if='tabSeleccionado === 0' :class='{ disabled : tabSeleccionado != 0 }' @click='guardarDatosPersona'>
      <label class='txt-footer-der' v-if='tabSeleccionado === 0'>{{ msj.grabardatos }}</label>
      <!-- Guardar Foto -->
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' v-if='tabSeleccionado === 1' :class='{ disabled : tabSeleccionado != 1 }' @click='guardarFotoPersona'>
      <label class='txt-footer-der' v-if='tabSeleccionado === 1'>{{ msj.grabarfoto }}</label>
      <!-- Borrar Foto -->
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-SUPR.gif' v-if='tabSeleccionado === 1' :class='{ disabled : tabSeleccionado != 1 }' @click='borrarFotoPersona'>
      <label class='txt-footer-der' v-if='tabSeleccionado === 1'>{{ msj.borrarfoto }}</label>
      <!-- Guardar Calendario laboral -->      
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' v-if='tabSeleccionado === 6' :class='{ disabled : tabSeleccionado != 0 }' @click='guardarCalenlab'>
      <label class='txt-footer-der' v-if='tabSeleccionado === 6'>{{ msj.grabarfestivo }}</label>
      <!-- Borrar Calendario laboral -->
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-SUPR.gif' v-if='tabSeleccionado === 6' :class='{ disabled : tabSeleccionado != 1 }' @click='borrarCalenlab'>
      <label class='txt-footer-der' v-if='tabSeleccionado === 6'>{{ msj.borrarfestivo }}</label>
       <!-- Crear Persona -->
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' v-if='tabSeleccionado === 7' :class='{ disabled : tabSeleccionado != 7 }' @click='crearPersona'>
      <label class='txt-footer-der' v-if='tabSeleccionado === 7'>{{ msj.grabardatos }}</label>
    </div>
    <!-- FIN. Footer de botones -->
  </div>
</template>
<script>
import { PersonaApiService } from '@/api/PersonaApiService'
import { VueTabs, VTab } from 'vue-nav-tabs/dist/vue-tabs.js'
import CreatePersona from '@/views/CreatePersona'
import PersonasTabDatosPersonales from '@/views/PersonasTabDatosPersonales'
import PersonasTabFoto from '@/views/PersonasTabFoto'
import PersonasTabVacaciones from '@/views/PersonasTabVacaciones'
import PersonasTabFichajes from '@/views/PersonasTabFichajes'
import PersonasTabFichajesDetalle from '@/views/PersonasTabFichajesDetalle'
import PersonasTabJornada from '@/views/PersonasTabJornada'

// Tabs mantenimiento
import PersonasTabMantCalenlab from '@/views/mantenimiento/PersonasTabMantCalenlab'

import { Util } from '@/api/Util'

const personaApiService = new PersonaApiService()
const util = new Util()

export default {
  data () {
    return {
      personaLogin: {},
      personas: [],
      personasCompletas: [],
      selectedCard: -1,
      selectedPersona: null,
      urlImagen: process.env.VUE_APP_URL_API_PERSONA + 'getPersonaFoto/',
      personaAdd: 0,
      opUid: '9b5437b7-052b-4d6d-af36-a29ae028410b',
      userid: this.$route.query.userid,
      useruid: this.$route.query.useruid,
      totalMostrar: 8,
      grupoMostrar: 1,
      tabSeleccionado: 0,
      tabNewtab: '',
      tabOldtab: '',
      tabNombre: '',
      msj: {
        quitarpersona: this.$t('lang.msjconfirm.quitarpersona'),
        continuarsinguardar: this.$t('lang.msjconfirm.continuarsinguardar'),
        grabardatos: this.$t('lang.comun.grabardatos'),
        grabarfoto: this.$t('lang.comun.grabarfoto'),
        borrarfoto: this.$t('lang.comun.borrarfoto'),
        totalper: this.$t('lang.personas.totalper'),
        addpersona: this.$t('lang.personas.addpersona'),
        quitar: this.$t('lang.comun.quitar'),
        anhadir: this.$t('lang.comun.anhadir'),
        siguiente: this.$t('lang.comun.siguiente'),
        anterior: this.$t('lang.comun.anterior'),
        grabarfestivo: this.$t('lang.comun.grabarfestivo'),
        borrarfestivo: this.$t('lang.comun.borrarfestivo')
      },
      tabnombres: {
        tabdatos: this.$t('lang.tabs.tabdatos'),
        tabfoto: this.$t('lang.tabs.tabfoto'),
        tabvacaciones: this.$t('lang.tabs.tabvacaciones'),
        tabfichajes: this.$t('lang.tabs.tabfichajes'),
        tabfichajesdetalle: this.$t('lang.tabs.tabfichajesdetalle'),
        tabjornada: this.$t('lang.tabs.tabjornada'),
        tabmantcalenlab: this.$t('lang.tabs.tabmantcalenlab'),
        tabcrear: this.$t('lang.tabs.tabcrear')
      },
      shift: false,
      ctrl: false,
      event: {
        clickCrearPersona: 0,
        clickGuardarDatosPersona: 0,
        clickGuardarFotoPersona: 0,
        clickBorrarFotoPersona: 0,
        clickGuardarCalenlab: 0,
        clickBorrarCalenlab: 0
      },
      lang: this.$route.query.lang,
      perMant: true
    }
  },
  components: {
    VueTabs,
    VTab,
    CreatePersona,
    PersonasTabDatosPersonales,
    PersonasTabFoto,
    PersonasTabVacaciones,
    PersonasTabFichajes,
    PersonasTabFichajesDetalle,
    PersonasTabJornada,

    // Mantenimiento
    PersonasTabMantCalenlab
  },
  created () {
    this.init()
    this.mountListenerTeclas()
    // Guardamos el usuario en sesion
    if (this.userid) {
      sessionStorage.setItem('userid', this.userid)
    }
    if (this.useruid) {
      sessionStorage.setItem('useruid', this.useruid)
      this.findPersona()
    }
    if (this.opUid) {
      sessionStorage.setItem('opUid', this.opUid)
    }
    if (this.lang) {
      sessionStorage.setItem('lang', this.lang)
    } else { // por defecto castellano
      sessionStorage.setItem('lang', 'es')
    }
  },
  computed: {
    hasPrev: function () {
      if (this.grupoMostrar > 1) {
        return true
      } else {
        return false
      }
    },
    hasNext: function () {
      if (this.grupoMostrar < this.totalGrupos) {
        return true
      } else {
        return false
      }
    },
    totalPersonas: function () {
      if (this.personas) {
        return this.personas.length
      } else {
        return 0
      }
    },
    totalGrupos: function () {
      if ((this.totalPersonas > 0) && (this.totalMostrar > 0)) {
        if (this.totalMostrar > this.totalPersonas) { // Caso 1: hay menos personas que personas a mostrar
          return 1
        } else { // Caso 2: hay mas personas que personas a mostrar, calculamos cuantos grupos se generan
          if (this.totalPersonas % this.totalMostrar > 0) {
            return ((Math.floor(this.totalPersonas / this.totalMostrar)) + 1)
          } else {
            return (Math.round(this.totalPersonas / this.totalMostrar))
          }
        }
      } else {
        return 0
      }
    },
    personasMostrar: function () {
      var result = []
      if (this.grupoMostrar === 1) {
        for (let i = 0; i < this.personas.length && i < this.totalMostrar; i++) {
          result.push(this.personas[i])
        }
      } else {
        var indice = (this.grupoMostrar - 1) * this.totalMostrar
        for (let i = indice; i < this.personas.length && i < (this.totalMostrar * this.grupoMostrar); i++) {
          result.push(this.personas[i])
        }
      }
      return result
    },
    isPersonaAddSelected: function () {
      if (this.personaAdd === 0) {
        return false
      } else {
        return true
      }
    },
    isPersonaRemSelected: function () {
      if (this.selectedPersona) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    init () {
      this.getPersonasByOpUid(this.opUid)
      this.getPersonasSelect(this.opUid)
    },
    mountListenerTeclas () {
      window.addEventListener('keydown', (e) => {
        if (e.keyCode === 16) { // Shift
          this.shift = true
        }
        if (e.keyCode === 17) { // Ctrl
          this.ctrl = true
        }
      })
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 34) {
          if (this.shift) { // (SHIFT + Av Pag) Grupo siguiente
            this.grupoSiguiente()
          } else { // (Av Pag) Siguiente persona
            if (this.selectedCard !== -1 && (this.selectedCard + 1 < this.personasMostrar.length)) {
              this.selectCard(this.personasMostrar[this.selectedCard + 1], this.selectedCard + 1)
            }
          }
        } else if (e.keyCode === 33) {
          if (this.shift) { // (SHIFT + Re Pag) Grupo anterior
            this.grupoAnterior()
          } else { // (Re Pag) Anterior persona
            if (this.selectedCard !== -1 && (this.selectedCard - 1 >= 0)) {
              this.selectCard(this.personasMostrar[this.selectedCard - 1], this.selectedCard - 1)
            }
          }
        } else if (e.keyCode === 16) { // SHIFT
          this.shift = false
        } else if (e.keyCode === 17) { // CTRL
          this.ctrl = false
        } else if (e.keyCode === 65) { // Tab Datos personales CTRL + SHIFT + A
          if (this.ctrl && this.shift) {
            this.tabNombre = this.tabnombres.tabdatos
          }
        } else if (e.keyCode === 83) { // Tab Foto CTRL + SHIFT + S
          if (this.ctrl && this.shift) {
            this.tabNombre = this.tabnombres.tabfoto
          }
        } else if (e.keyCode === 188) { // Tab Foto CTRL + (),)
          if (this.ctrl) {
            this.removePersona()
          }
        } else if (e.keyCode === 190) { // Tab Foto CTRL + (.)
          if (this.ctrl) {
            this.addPersona()
          }
        }
      })
    },
    handleTabChange (tabIndex, newTab, oldTab) {
      switch (tabIndex) {
        case 0:
          this.tabSeleccionado = 0
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 1:
          this.tabSeleccionado = 1
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 2:
          this.tabSeleccionado = 2
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 3:
          this.tabSeleccionado = 3
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 4:
          this.tabSeleccionado = 4
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 5:
          this.tabSeleccionado = 5
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 6:
          this.tabSeleccionado = 6
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        case 7:
          this.tabSeleccionado = 7
          this.tabNewtab = newTab
          this.tabOldtab = oldTab
          break
        default:
          break
      }
    },
    getAllPersona () {
      personaApiService.getAllPersona()
        .then(data => {
          util.mostrarEnConsola('Personas - getAllPersona', data.length, 'OK')
          this.personas = data
        })
        .catch(error => {
          util.mostrarEnConsola('Personas - getAllPersona', error, 'ERROR')
        })
    },
    getPersonasByOpUid (OpUid) {
      if (OpUid) {
        personaApiService.getPersonasByOpUid(OpUid)
          .then(data => {
            util.mostrarEnConsola('Personas - getPersonasByOpUid', data.length, 'OK')
            this.personas = data
            if (this.personas.length > 0) {
              for (let i = 0; i < this.personas.length; i++) {
                if (this.personas[i].mspersonapais === null || this.personas[i].mspersonapais === '') {
                  this.personas[i].mspersonapais = '0'
                }
                if (this.personas[i].mspersonaprovincia === null || this.personas[i].mspersonaprovincia === '') {
                  this.personas[i].mspersonaprovincia = '0'
                }
                if (this.personas[i].mspersonasexo === null || this.personas[i].mspersonasexo === '') {
                  this.personas[i].mspersonasexo = '0'
                }
                this.personas[i].isSelected = false
              }
              // Comprobamos si es inicio de session
              if (this.selectedCard === -1 && this.personas.length > 0) {
                this.selectedCard = 0
                this.selectedPersona = this.personas[0]
                this.selectedPersona.isSelected = true
                this.personas[0].isSelected = true
                this.guardarPersonaSesion(this.selectedPersona)
              }
            }
          })
          .catch(error => {
            util.mostrarEnConsola('Personas - getPersonasByOpUid', error, 'ERROR')
          })
      }
    },
    getPersonaById (personaid) {
      personaApiService.getPersonaById(personaid)
        .then(data => {
          util.mostrarEnConsola('Personas - getPersonaById', data.length, 'OK')
          this.personas = data
        })
        .catch(error => {
          util.mostrarEnConsola('Personas - getPersonaById', error, 'ERROR')
        })
    },
    findPersona () {
      if (this.useruid) {
        personaApiService.findPersona({mspersonauid: this.useruid})
          .then(data => {
            if (data.mspersonaid) {
              util.mostrarEnConsola('Personas - findPersona', data.mspersonaid, 'OK')
              this.personaLogin = data
              sessionStorage.setItem('persona', this.personaLogin)
              sessionStorage.setItem('userid', this.personaLogin.mspersonaid)
            }
          })
          .catch(error => {
            util.mostrarEnConsola('Personas - findPersona', error, 'ERROR')
          })
      }
    },
    getPersonasNombreLike (nombre) {
      personaApiService.getPersonasNombreLike(nombre)
        .then(data => {
          util.mostrarEnConsola('Personas - getPersonasNombreLike', data.length, 'OK')
          this.personas = data
        })
        .catch(error => {
          util.mostrarEnConsola('Personas - getPersonasNombreLike', error, 'ERROR')
        })
    },
    isPersonaIgual (personaActual, personaSesion) {
      if (personaSesion && personaActual) {
        if (personaSesion.mspersonaalias !== personaActual.mspersonaalias) {
          return false
        } else if (personaSesion.mspersonadni !== personaActual.mspersonadni) {
          return false
        } else if (personaSesion.mspersonafechanac !== personaActual.mspersonafechanac) {
          return false
        } else if (personaSesion.mspersonanombre !== personaActual.mspersonanombre) {
          return false
        } else if (personaSesion.mspersonaapellido1 !== personaActual.mspersonaapellido1) {
          return false
        } else if (personaSesion.mspersonaapellido2 !== personaActual.mspersonaapellido2) {
          return false
        } else if (personaSesion.mspersonacalle !== personaActual.mspersonacalle) {
          return false
        } else if (personaSesion.mspersonacodpostal !== personaActual.mspersonacodpostal) {
          return false
        } else if (personaSesion.mspersonasexo !== personaActual.mspersonasexo) {
          return false
        } else if (personaSesion.mspersonanss !== personaActual.mspersonanss) {
          return false
        } else if (personaSesion.mspersonalenguaje !== personaActual.mspersonalenguaje) {
          return false
        } else if (personaSesion.mspersonaobservaciones !== personaActual.mspersonaobservaciones) {
          return false
        } else if (personaSesion.mspersonapais !== personaActual.mspersonapais) {
          return false
        } else if (personaSesion.mspersonaprovincia !== personaActual.mspersonaprovincia) {
          return false
        } else if (personaSesion.mspersonapoblacion !== personaActual.mspersonapoblacion) {
          return false
        } else if (personaSesion.mspersonaemail !== personaActual.mspersonaemail) {
          return false
        } else if (personaSesion.mspersonatelmovil !== personaActual.mspersonatelmovil) {
          return false
        } else if (personaSesion.mspersonatel !== personaActual.mspersonatel) {
          return false
        } else if (personaActual.imagen) { // Se ha modificado la foto
          return false
        }
        return true
      }
    },
    selectCard (selectedPersonaParam, selectedIndex) {
      // Comprobamos si hay cambios
      var personaActual = null
      var personaSesion = null
      if (this.selectedPersona) {
        personaActual = this.selectedPersona
      }
      if (sessionStorage.getItem('personaAux')) {
        // Parseamos la persona almacenada en session
        personaSesion = JSON.parse(sessionStorage.getItem('personaAux'))
      }
      if (!this.isPersonaIgual(personaActual, personaSesion)) { // Ha habido cambios
        if (confirm(this.msj.continuarsinguardar)) {
          // Volvemos a poner la persona anterior en personas
          this.selectedPersona = JSON.parse(sessionStorage.getItem('personaAux'))
          this.quitarSeleccionPersona()
          // Si hemos seleccionado otra persona diferente a la seleccionada, guardamos un snapshot de la persona
          // para comparar cuando se cambien de persona
          if (this.selectedCard !== selectedIndex) {
            this.selectedCard = selectedIndex
            this.selectedPersona.isSelected = false
            this.selectedPersona = selectedPersonaParam
            this.selectedPersona.isSelected = true
            // Guardamos la persona en formato JSON para compararlo al cambiar de pestanha o persona
            this.guardarPersonaSesion(selectedPersonaParam)
          }
        }
      } else { // No ha habido cambios
        if (this.selectedCard !== selectedIndex) {
          // Quitamos la seleccion anterior
          this.quitarSeleccionPersona()
          this.selectedCard = selectedIndex
          this.selectedPersona = selectedPersonaParam
          this.selectedPersona.isSelected = true
          // Guardamos la persona en formato JSON para compararlo al cambiar de pestanha o persona
          this.guardarPersonaSesion(selectedPersonaParam)
          // Seleccionamos el tab de datos
          this.tabNombre = this.tabnombres.tabdatos
        }
      }
    },
    quitarSeleccionPersona () {
      if (this.personas) {
        for (let i = 0; i < this.personas.length; i++) {
          if (this.selectedPersona.mspersonaid === this.personas[i].mspersonaid) {
            this.selectedPersona.isSelected = false
            this.personas.splice(i, 1, this.selectedPersona)
            break
          }
        }
      }
    },
    getImgUrl: function (mspersonauid) {
      return this.urlImagen + mspersonauid + '?' + Math.random()
    },
    getPersonasSelect (OpUid) {
      if (OpUid) {
        personaApiService.getPersonasNotInOpUid(OpUid)
          .then(data => {
            util.mostrarEnConsola('Personas - getPersonasSelect', data.length, 'OK')
            this.personasCompletas = data
          })
          .catch(error => {
            util.mostrarEnConsola('Personas - getPersonasNotInOpUid', error, 'ERROR')
          })
      }
    },
    addPersona () {
      if (this.personaAdd !== 0) { // Comprobamos si hay persona seleccionada en el select
        for (let i = 0; i < this.personasCompletas.length; i++) {
          const per = this.personasCompletas[i]
          per.isSelected = false
          if (per.mspersonaid === this.personaAdd) {
            // Guardamos la seleccion en la base de datos
            // TO-DO Gestionar el rol
            personaApiService.createPersonaOp(per.mspersonaid, per.mspersonauid, this.opUid, 2)
              .then(data => {
                // Quitamos la seleccion anterior
                this.quitarSeleccionPersona()
                this.personas.push(per)
                this.personasCompletas.splice(i, 1)
                this.personaAdd = 0
                // Mostramos el ultimo grupo y seleccionamos el que hemos anhadido
                this.grupoMostrar = this.totalGrupos
                this.personasMostrar[this.personasMostrar.length - 1].isSelected = true
                this.selectedPersona = this.personasMostrar[this.personasMostrar.length - 1]
                this.selectedCard = this.personasMostrar.length - 1
                this.guardarPersonaSesion(this.selectedPersona)
                util.mostrarEnConsola('Personas - createPersonaOp', 'mspersonaid: ' + per.mspersonaid + ', opUid: ' + this.opUid + ', RESPONSE: ' + data, 'OK')
              })
              .catch(error => {
                util.mostrarEnConsola('Personas - createPersonaOp', error, 'ERROR')
              })
            break
          }
        }
        // Seleccionamos el tab de datos
        this.tabNombre = this.tabnombres.tabdatos
      }
    },
    removePersona () {
      if (this.selectedPersona) {
        if (confirm(this.msj.quitarpersona)) {
          // Borramos la relacion de la persona con la op
          // TO-DO Gestionar el rol
          personaApiService.deletePersonaOp(this.selectedPersona.mspersonaid, this.selectedPersona.msperosnauid, this.opUid, 2)
            .then(data => {
              if (data.deleted) {
                util.mostrarEnConsola('Personas - deletePersonaOp', 'mspersonaid: ' + this.selectedPersona.mspersonaid + ', opUid: ' + this.opUid + ', RESPONSE: ' + data.deleted, 'OK')
                // Devolvemos la persona a la lista de personas seleccionables
                this.personasCompletas.push(this.selectedPersona)
                // Reordenamos personasCompletas
                this.personasCompletas.sort((a, b) => (a.mspersonaapellido1 > b.mspersonaapellido1) ? 1 : (a.mspersonaapellido1 === b.mspersonaapellido1) ? ((a.mspersonanombre > b.mspersonanombre) ? 1 : -1) : -1)
                // Quitamos la persona de las personas
                for (let i = 0; i < this.personas.length; i++) {
                  if (this.selectedPersona.mspersonaid === this.personas[i].mspersonaid) {
                    this.personas.splice(i, 1)
                    break
                  }
                }
                // Quitamos la persona de las personasMostrar
                for (let j = 0; j < this.personasMostrar.length; j++) {
                  if (this.selectedPersona.mspersonaid === this.personasMostrar[j].mspersonaid) {
                    this.personasMostrar.splice(j, 1)
                    break
                  }
                }
                // Seleccionamos la siguiente persona
                // Primero comprobamos si quedan mas peronas en el grupo
                if (this.personasMostrar.length === 0) {
                  this.grupoMostrar--
                  this.selectedCard = 0
                  this.selectedPersona = this.personasMostrar[this.selectedCard]
                  this.guardarPersonaSesion(this.selectedPersona)
                } else {
                  // Si hay persona a la izquierda, la seleccionamos
                  if (this.selectedCard - 1 >= 0) {
                    this.selectedCard -= 1
                    this.selectedPersona = this.personasMostrar[this.selectedCard]
                    this.selectedPersona.isSelected = true
                    this.guardarPersonaSesion(this.selectedPersona)
                  } else if (this.selectedCard === 0) {
                    if (this.personasMostrar.length !== 0) {
                      this.selectedPersona = this.personasMostrar[this.selectedCard]
                      this.selectedPersona.isSelected = true
                      this.guardarPersonaSesion(this.selectedPersona)
                    } else {
                      this.selectedPersona = null
                      this.selectedCard = -1
                    }
                  } else {
                    this.selectedPersona = null
                    this.selectedCard = -1
                  }
                  if (this.totalPersonas < this.personasMostrar) {
                    this.selectGrupo = 1
                  }
                }
              }
            })
            .catch(error => {
              util.mostrarEnConsola('Personas - deletePersonaOp', error, 'ERROR')
            })
        }
        // Seleccionamos el tab de datos
        this.tabNombre = this.tabnombres.tabdatos
      }
    },
    selectGrupo (n) {
      // Comprobamos si hay cambios
      var personaSesion = null
      var personaActual = this.selectedPersona
      if (sessionStorage.getItem('personaAux')) {
        // Parseamos la persona almacenada en session
        personaSesion = JSON.parse(sessionStorage.getItem('personaAux'))
      }
      if (!this.isPersonaIgual(personaActual, personaSesion)) { // Persona modificada
        if (confirm(this.msj.continuarsinguardar)) {
          // Volvemos a poner la persona anterior en personas
          this.selectedPersona = JSON.parse(sessionStorage.getItem('personaAux'))
          this.quitarSeleccionPersona()
          this.grupoMostrar = n
          // Cuando cambiamos de grupo, seleccionamos la primera persona
          if (this.selectedCard !== -1) {
            this.selectedPersona = this.personasMostrar[0]
            this.selectedPersona.isSelected = true
            this.selectedCard = 0
            // Guardamos la persona en formato JSON para compararlo al cambiar de pestanha o persona
            this.guardarPersonaSesion(this.selectedPersona)
          }
        }
      } else { // Persona no modificada
        // Quitamos la seleccion de la persona anterior
        this.quitarSeleccionPersona()
        this.grupoMostrar = n
        // Cuando cambiamos de grupo, seleccionamos la primera persona
        if (this.selectedCard !== -1) {
          this.selectedPersona = this.personasMostrar[0]
          this.selectedPersona.isSelected = true
          this.selectedCard = 0
          // Guardamos la persona en formato JSON para compararlo al cambiar de pestanha o persona
          this.guardarPersonaSesion(this.selectedPersona)
        }
      }
    },
    grupoAnterior () {
      if (this.grupoMostrar - 1 > 0) {
        this.selectGrupo(--this.grupoMostrar)
        this.tabNombre = this.tabnombres.tabdatos
      }
    },
    grupoSiguiente () {
      if (this.grupoMostrar + 1 <= this.totalGrupos) {
        this.selectGrupo(++this.grupoMostrar)
        this.tabNombre = this.tabnombres.tabdatos
      }
    },
    crearPersona () {
      this.event.clickCrearPersona++
    },
    guardarDatosPersona () {
      this.event.clickGuardarDatosPersona++
    },
    guardarFotoPersona () {
      this.event.clickGuardarFotoPersona++
    },
    borrarFotoPersona () {
      this.event.clickBorrarFotoPersona++
    },
    guardarCalenlab () {
      this.event.clickGuardarCalenlab++
    },
    borrarCalenlab () {
      this.event.clickBorrarCalenlab++
    },
    guardarPersonaSesion (persona) {
      if (persona) {
        sessionStorage.setItem('personaAux', JSON.stringify(persona))
      }
    }
  }
}
</script>
